import React from 'react';

import { Box, Flex, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconCircleCheck, IconCircleX, IconClockHour4, IconRotateClockwise } from '@tabler/icons-react';
import { getEvaluationTestReadableTimestamp } from 'shared/constants/evaluation';
import { EvaluationTest, EvaluationTestStatus } from 'shared/interfaces/Evaluation';

interface EvaluationTestNavigationItemProps {
  evaluationTest: EvaluationTest;
  setSelectedTestId: (testId: string) => void;
  isSelected: boolean;
  isLast: boolean;
}

export function EvaluationTestNavigationItem({
  evaluationTest,
  setSelectedTestId,
  isSelected,
  isLast
}: EvaluationTestNavigationItemProps) {
  const theme = useMantineTheme();

  const getStatusIcon = (test: EvaluationTest) => {
    switch (test.status) {
      case EvaluationTestStatus.COMPLETED:
        return <IconCircleCheck color={theme.other.status.completed} />;
      case EvaluationTestStatus.RUNNING:
        return <IconRotateClockwise color={theme.other.status.running} />;
      case EvaluationTestStatus.FAILED:
        return <IconCircleX color={theme.other.status.failed} />;
      case EvaluationTestStatus.PENDING:
      default:
        return <IconClockHour4 color={theme.other.status.pending} />;
    }
  };
  return (
    <Box
      key={evaluationTest._id}
      sx={(theme) => ({
        borderBottom: isLast ? 'none' : `1px solid ${theme.colors.gray[2]}`,
        backgroundColor: isSelected ? theme.colors.gray[0] : 'transparent',
        '&:hover': { backgroundColor: theme.colors.gray[0] },
        cursor: 'pointer'
      })}
      onClick={() => setSelectedTestId(evaluationTest._id)}>
      <Flex align="flex-start" py="xs" px="md">
        <Box mt={4} mr={10}>
          {getStatusIcon(evaluationTest)}
        </Box>
        <Stack spacing={1} style={{ flex: 1 }}>
          <Text size="sm" fw={500} lineClamp={2} lh={1.3}>
            {evaluationTest.input.singleStepTestInput.content}
          </Text>
          <Text size="xs" color="dimmed">
            {getEvaluationTestReadableTimestamp(evaluationTest)}
          </Text>
        </Stack>
      </Flex>
    </Box>
  );
}
